import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Text } from '@dixa/lib-shared-habla';
import { CompareContactsTable } from '../compareContactsTable/compareContactsTable';
/** Component that shows a comparison of two users */
export const CompareContacts = ({ targetContact, sourceContact, previewContact, }) => {
    return (_jsxs(_Fragment, { children: [_jsx(Box, Object.assign({ margin: "0 0 400 0" }, { children: _jsx(Text.Paragraph, { children: "Contact information from all contacts will be combined into one unified contact." }) })), _jsx(CompareContactsTable, { contacts: [targetContact, sourceContact], previewContact: previewContact })] }));
};
